/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiAIPromptStatus;
(function (ApiAIPromptStatus) {
    ApiAIPromptStatus["AI_PROMPT_STATUS_PENDING"] = "AIPromptStatusPending";
    ApiAIPromptStatus["AI_PROMPT_STATUS_COMPLETED"] = "AIPromptStatusCompleted";
    ApiAIPromptStatus["AI_PROMPT_STATUS_FAILED"] = "AIPromptStatusFailed";
    ApiAIPromptStatus["AI_PROMPT_STATUS_CANCELLED"] = "AIPromptStatusCancelled";
})(ApiAIPromptStatus || (ApiAIPromptStatus = {}));
export function ApiAIPromptStatusFromJSON(json) {
    return ApiAIPromptStatusFromJSONTyped(json, false);
}
export function ApiAIPromptStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiAIPromptStatusToJSON(value) {
    return value;
}
